import React, { useState } from "react";
import { Badge, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BadgeList = ({
  data = [],
  maxVisible = 3,
  onRemove,
  badgeVariant = "secondary"
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!data?.length) {
    return null;
  }

  const visible = expanded ? data : data.slice(0, maxVisible);
  const hiddenCount = expanded ? 0 : data.length - visible.length;

  return (
    <div className="badge-list-custom d-flex flex-wrap align-items-center">
      {visible.map((item) => (
        <Badge
          key={item.value}
          pill
          bg={badgeVariant}
          className="d-inline-flex align-items-center me-2 mb-2"
        >
          {onRemove && (
            <Button
              variant="link"
              className="p-0 me-1 pr-1 text-light text-decoration-none"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(item);
              }}
            >
              ×
            </Button>
          )}
          {item.label}
        </Badge>
      ))}
      {!expanded && hiddenCount > 0 && (
        <span
          className="ms-1 text-primary cursor-pointer"
          onClick={() => setExpanded(true)}
          role="button"
        >
          + {t('{{hiddenCount}} more', { hiddenCount })}
        </span>
      )}
      {expanded && data.length > maxVisible && (
        <span
          className="ms-1 text-primary cursor-pointer"
          onClick={() => setExpanded(false)}
          role="button"
        >
          {t("Show less")}
        </span>
      )}
    </div>
  );
};

export default BadgeList;
